export var parseBreadcrumbsFromStaticApi = function parseBreadcrumbsFromStaticApi(breadcrumbs) {
  return (breadcrumbs !== null && breadcrumbs !== void 0 ? breadcrumbs : []).filter(function (breadcrumb) {
    return !!breadcrumb.id && !!breadcrumb.title;
  }).map(function (breadcrumb) {
    return {
      ItemLabel: breadcrumb.title,
      Url: breadcrumb.id
    };
  });
};
//# sourceMappingURL=parseBreadcrumbsFromStaticApi.js.map